import { render, staticRenderFns } from "./RdButtonSwitcher.vue?vue&type=template&id=000e3ad8&scoped=true&"
import script from "./RdButtonSwitcher.vue?vue&type=script&lang=ts&"
export * from "./RdButtonSwitcher.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "000e3ad8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
